import { Outlet } from "react-router-dom";

export default function FarmDiaryLayout() {
  return <Outlet />;
}
